var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('li',{staticClass:"suggest"},[_c('strong',{staticClass:"suggest_title"},[_vm._v("不好！你好像迷路了，请检查以下域名是否正确：")]),_c('p',{staticClass:"url",attrs:{"id":"url"}},[_vm._v(_vm._s(_vm.url))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }